import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText } from '@mui/material';

type Props = {
  open: boolean;
  onClose: () => void;
  roomNames: Array<string>;
};

export default function PromotionRoomsModal({ open, onClose, roomNames }: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Applicable rooms</DialogTitle>
      <DialogContent>
        <List disablePadding>
          {roomNames.map((name) => (
            <ListItem key={name} disableGutters>
              <ListItemText primary={name} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
